var map = {
	"./ar.json": 750,
	"./en.json": 751,
	"./localise_stf/ar.json": 352,
	"./localise_stf/en.json": 353,
	"./menu_ar.json": 354,
	"./menu_en.json": 355,
	"./menu_kw_ar.json": 265,
	"./menu_kw_en.json": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 749;